import { defaultTextColor } from './defaults';
import { isValidColor } from './color';
const verifyOrFallback = verifyOrFallbackFactory();
export const verifyOrFallbackColor = (fallback) => verifyOrFallback(isValidColor, fallback);
export const verifyOrFallbackTextColor = verifyOrFallbackColor(defaultTextColor);
function verifyOrFallbackFactory() {
    return (predicate, fallback) => (value) => {
        if (predicate(value)) {
            return value;
        }
        return fallback;
    };
}
//# sourceMappingURL=verify-or-fallback.js.map